import React, { useEffect } from 'react'
import { Router, Route, Switch, Redirect } from 'react-router-dom'

import App from 'Containers/App/index'
import Login from 'Containers/Auth/Login'
import { clearAllFilters } from 'Reducers/Filter/actions'
import Logout from 'Containers/Auth/Logout'
import ForgotPassword from 'Containers/Auth/ForgotPassword'
import ResetPassword from 'Containers/Auth/ResetPassword'
import ResetPasswordSuccess from 'Components/Auth/ResetPasswordSuccess'
import VerifyEmail from 'Components/Auth/VerifyEmail'

import APIErrorModal from './../../Containers/APIErrorHandler'
import store from 'Config/store'
import { PATHS } from 'Config/Routing/paths'
import { history } from 'Config/history'
import Zendesk from './../../Containers/Zendesk'
import { PrivateRoute } from './auth'
import NpsScoreVoterPage from '../../Containers/NpsScoreVotedPage'

export const MainRouter = props => {
  useEffect(() => {
    let lastRoute = null
    history.listen(location => {
      if (location.pathname !== lastRoute) {
        store.dispatch(clearAllFilters())
      }
      lastRoute = location.pathname
    })
  }, [])

  return (
    <div>
      <Router history={history}>
        <Zendesk>
          <Switch>
            <Route path={PATHS.main.login} component={Login} />
            <Route path={PATHS.main.logout} component={Logout} />
            <Route path={PATHS.main.requestPass} component={ForgotPassword} />
            <Route path={PATHS.main.resetPass} component={ResetPassword} />
            <Route
              path={PATHS.main.resetPassSuccess}
              component={ResetPasswordSuccess}
            />
            <Route path={PATHS.main.verifyEmail} component={VerifyEmail} />
            <Route path={PATHS.main.npsScore} component={NpsScoreVoterPage} />
            <Route path={PATHS.main.dashboard}>
              <PrivateRoute>
                <App />
              </PrivateRoute>
            </Route>
            <Redirect from="/" to={PATHS.main.dashboard} />
          </Switch>
        </Zendesk>
      </Router>
      <APIErrorModal />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Config/Routing/MainRouter.js